class ToggleElement {
  constructor(element) {
    this.element = element
    this.target = element.getAttribute('data-target')
    this.classes = element.getAttribute('data-classes')
    this.siblingsClass = element.getAttribute('data-siblings')
    this.delayedClasses = element.getAttribute('data-delayed-classes')


    const targetDomEl = document.querySelector(this.target)

    this.scrollBehabviour = element.getAttribute('data-scroll')

    this.element.addEventListener('click', (event) => {
      let elementAriaExpanded = (this.element.getAttribute('aria-expanded') === 'true')

      event.preventDefault()

      const siblings = [...document.querySelectorAll(this.siblingsClass)]

      if ( elementAriaExpanded ) {
        siblings.forEach(item => item.setAttribute('aria-expanded', 'false'))
      } else {
        siblings.forEach(item => item.setAttribute('aria-expanded', 'true'))
      }

      //for animaiton and visible in css
      if ( this.delayedClasses) {
        if (elementAriaExpanded) {
          setTimeout(() => {
            targetDomEl.classList.remove(this.delayedClasses)
          }, 300);
        }else{
          targetDomEl.classList.add(this.delayedClasses)
        }
      }

      targetDomEl.classList.toggle(this.classes)


    }, false)

  }
}

export default ToggleElement
